// Module
var code = "<div layout=\"row\" class=\"full-height margin-right-5\"> <md-icon md-svg-icon=\"relation\" class=\"bringoz-icon padding-0 margin-right-0\"> <md-tooltip md-direction=\"top\"> <span>{{$ctrl.count}} {{'Linked tasks' | translate}}</span> </md-tooltip> </md-icon> <span class=\"md-tiny\">{{$ctrl.count}}</span> </div> ";
// Exports
export default code;